import { render, staticRenderFns } from "./datiGenerali.vue?vue&type=template&id=2c3a42e2"
import script from "./datiGenerali.vue?vue&type=script&lang=js"
export * from "./datiGenerali.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports